@if (alert | async; as alert) {
  <div class="container" [@showHide]="(isShown | async)" role="status" aria-live="polite"
    [style.background-color]="colorOf(alert)" [class.on-light-bg]="isColored(alert)">
    <div>
      <i class="fa-2x" [ngClass]="iconOf(alert)" aria-hidden="true"></i>
    </div>
    <div class="content" [innerHTML]="alert.text[languageService.language]">
    </div>
    <div class="h4 alert-close">
      <span class="fa-stack fa-sm" (click)="onClose(alert.id)" role="button" tabindex="0"
        (keyup.enter)="onClose(alert.id)" aria-label="Fermer l'alerte">
        <i class="fas fa-stack-2x fa-circle" aria-hidden="true"></i>
        <i class="fal fa-stack-1x fa-times" aria-hidden="true"></i>
      </span>
    </div>
  </div>
}
